import {
  useRegisterUnsavedChanges,
  type UseRegisterUnsavedChangesOptions,
} from '../useRegisterUnsavedChanges';

export type UseSnapshotDirtyStateOptions = Omit<UseRegisterUnsavedChangesOptions, 'isDirty'> & {
  isDirty: boolean;
};

/** Registers a boolean dirty flag (settings save card, viewer editor, custom compares). */
export function useSnapshotDirtyState(options: UseSnapshotDirtyStateOptions): void {
  useRegisterUnsavedChanges(options);
}
